import BaseService from '_services/rest/base';

class PuzzleService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/puzzle`;
  }

  deletePuzzle(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'delete')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  deleteQuestion(id) {
    return this.request(`${this.getUrl()}/question/${id}`, null, 'delete')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getPuzzles(params) {
    const filters = {
      search: params.search,
      status: params.status,
      templates: params.templates,
      template_id: params.template_id,
    };

    return this.request(
      `${this.getUrl()}/${params.slug}/all/${params.skip}/${params.take}`,
      filters,
    )
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getPuzzleById(id, search = null) {
    return this.request(`${this.getUrl()}/${id}`, { search })
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getAnswerDirections() {
    return this.request(`${this.getUrl()}/answer/directions`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getArrowDirections() {
    return this.request(`${this.getUrl()}/arrow-directions`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getArrowPositions() {
    return this.request(`${this.getUrl()}/arrow-positions`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getQuestionSizes() {
    return this.request(`${this.getUrl()}/question/sizes`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getPuzzle(slug) {
    return this.request(`${this.getUrl()}/${slug}/all`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getQuestionsByAnswerId(id, params = {}) {
    return this.request(`${this.getUrl()}/answer/${id}/questions`, params)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getUrlSave(id, url = '') {
    if (id) {
      return {
        url: `${this.getUrl()}${url}/${id}`,
        method: 'put',
      };
    }
    return {
      url: `${this.getUrl()}${url}`,
      method: 'post',
    };
  }

  saveAnswer(model) {
    const meta = this.getUrlSave(model.id, '/answer');
    return this.request(meta.url, model, meta.method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveQuestion(model) {
    return this.request(`${this.getUrl()}/question`, model, 'post')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  editQuestion(model) {
    return this.request(`${this.getUrl()}/question/${model.id}`, model, 'put')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  save(model) {
    const meta = this.getUrlSave(model.id);
    return this.request(meta.url, model, meta.method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getWordByTerm(search, level) {
    return this.request(`${this.getUrl()}/answer/term`, { search, level })
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getTemplates(params) {
    const filters = { search: params.search, templates: true };

    return this.request(`${this.getUrl()}/${params.slug}/search`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  generatePuzzle(slug, seed) {
    return this.request(`${this.getUrl()}/${slug}/generate`, seed, 'post')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  updateStatus(ids, status) {
    const payload = { ids, status };

    return this.request(`${this.getUrl()}/update-status`, payload, 'put')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  send(ids) {
    const payload = { ids };

    return this.request(`${this.getUrl()}/send`, payload, 'post').catch(err => {
      throw err;
    });
  }

  syncQuestions(id) {
    return this.request(
      `${this.getUrl()}/${id}/sync-questions`,
      null,
      'post',
    ).catch(err => {
      throw err;
    });
  }
}

export default new PuzzleService();
